import { render, staticRenderFns } from "./ReadDisclaimer.vue?vue&type=template&id=d66d05b2&scoped=true"
import script from "./ReadDisclaimer.vue?vue&type=script&lang=js"
export * from "./ReadDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./ReadDisclaimer.vue?vue&type=style&index=0&id=d66d05b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66d05b2",
  null
  
)

export default component.exports